var _circle, _path, _circle2, _path2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.64453,
    cy: 40.1242,
    r: 5.40356,
    transform: "rotate(45 7.64453 40.1242)",
    fill: "#FFCC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2592 7.27009C39.5033 7.75946 44.4467 9.93828 48.3459 13.4788C52.2452 17.0194 54.8895 21.7303 55.881 26.903C56.8726 32.0756 56.1579 37.4304 53.8444 42.162C51.5309 46.8935 47.7437 50.746 43.0523 53.1399C38.361 55.5339 33.0192 56.3399 27.8303 55.4368C22.6415 54.5337 17.8861 51.9702 14.2795 48.132",
    stroke: "#3098F3",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.0015,
    cy: 31.482,
    r: 8.78079,
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7959 25.2764C22.3724 28.7004 22.3725 34.2515 25.7964 37.6753C29.2202 41.0992 34.7713 41.0993 38.1953 37.6758L25.7959 25.2764Z",
    fill: "#05051E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5195,
    cy: 7.25977,
    r: 5.13343,
    transform: "rotate(45 34.5195 7.25977)",
    fill: "#082C4E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0566,
    cy: 51.373,
    r: 4.98842,
    transform: "rotate(45 46.0566 51.373)",
    fill: "#FE6571"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotion);
export default __webpack_public_path__ + "static/media/icon-motion.4f137ef72cdde1371ad4996508db1cfa.svg";
export { ForwardRef as ReactComponent };